<template>
  
  <div class="ui segment animated fadeIn">

    <form class="ui form">
      <div class="fields">
        <div class="two wide field">
          <label class="form-label">Status</label>
          <span v-if="customer.isBlocked" class="ui small label">
            <i class="ban red icon"></i> Bloqueado
          </span>
          <span v-else class="ui small label">
            <i class="check circle green icon"></i> Ativo
          </span>
        </div>
        <div class="two wide field">
          <label class="form-label">Código</label>
          <span>{{ customer.code + '-' + customer.unit }}</span>
        </div>
        <div class="twelve wide field">
          <label class="form-label">Razão Social</label>
          <span>{{ customer.name }}</span>
        </div>
      </div>
      <div class="fields">
        <div class="four wide field">
          <label class="form-label">Segmento</label>
          <span>{{ customer.segment }}</span>
        </div>
        <div class="twelve wide field">
          <label class="form-label">Nome Reduzido</label>
          <span>{{ customer.shortName }}</span>
        </div>        
      </div>
    </form>

  </div>

</template>

<script>

  export default {    
    props: ["customer"],
  }

</script>

